import React from 'react';
import { GlobeIcon, MailIcon, MapPinIcon, PhoneIcon, UserIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { ContactForm } from '../components/ContactForm';
import { company, decennale, zones } from '../data/site';
export function Contact() {
  return <>
      <PageHero eyebrow="Contact" title="Parlons de votre besoin" text="Appel, e-mail ou formulaire : Julien Nésius vous répond et établit votre devis sur demande." data-id="element-163" data-mp="1lpqku70qtnnu" />

      <section className="bg-white" data-id="element-164" data-mp="t24ews41m6xt">
        <div className="mx-auto max-w-content px-5 py-14 lg:px-8 lg:py-20" data-id="element-165" data-mp="t35th6k9pbka">
          <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-166" data-mp="17rk3q2k0k2av">
            <div className="lg:col-span-5" data-id="element-167" data-mp="130235flwk3qf">
              <h2 className="font-display text-[1.6rem] font-extrabold leading-tight tracking-tight text-navy-800 sm:text-3xl" data-id="element-168" data-mp="12z0h6g3clwtx">
                Coordonnées
              </h2>

              <address className="mt-7 divide-y divide-line border-y border-line not-italic" data-id="element-169" data-mp="abwi0rqxscq2">
                <div className="flex gap-4 py-4" data-id="element-170" data-mp="15fyjz7smyni1">
                  <UserIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-400" aria-hidden="true" data-id="element-171" data-mp="15dcgbj8v8s53" />
                  <div data-id="element-172" data-mp="1e7h41tspdnge">
                    <p className="font-display text-xs font-bold uppercase tracking-[0.14em] text-navy-400" data-id="element-173" data-mp="1e8aasurnwcyj">
                      Artisan
                    </p>
                    <p className="mt-1 font-display text-[1.05rem] font-bold text-navy-800" data-id="element-174" data-mp="mh2wsgf739dp">
                      {company.owner}
                    </p>
                  </div>
                </div>

                <div className="flex gap-4 py-4" data-id="element-175" data-mp="vgznsop24kbx">
                  <PhoneIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-400" aria-hidden="true" data-id="element-176" data-mp="vjc28rvlwck8" />
                  <div data-id="element-177" data-mp="26vcvok3f0p6b">
                    <p className="font-display text-xs font-bold uppercase tracking-[0.14em] text-navy-400" data-id="element-178" data-mp="26vwcfxhbx7ir">
                      Téléphone
                    </p>
                    <a href={company.phoneHref} className="mt-1 block font-display text-xl font-extrabold text-navy-800 transition-colors duration-150 ease-out hover:text-ember-500" data-id="element-179" data-mp="1m6kf35pfa6bh">
                      {company.phone}
                    </a>
                  </div>
                </div>

                <div className="flex gap-4 py-4" data-id="element-180" data-mp="1r4dm20yjv4ct">
                  <MailIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-400" aria-hidden="true" data-id="element-181" data-mp="13hxa0n78xgxw" />
                  <div data-id="element-182" data-mp="yfy87hr5ms32">
                    <p className="font-display text-xs font-bold uppercase tracking-[0.14em] text-navy-400" data-id="element-183" data-mp="1d773o7hqn7o4">
                      E-mail
                    </p>
                    <a href={company.emailHref} className="mt-1 block break-all font-display text-[1.05rem] font-bold text-navy-800 transition-colors duration-150 ease-out hover:text-ember-500" data-id="element-184" data-mp="18dvvo316wkum">
                      {company.email}
                    </a>
                  </div>
                </div>

                <div className="flex gap-4 py-4" data-id="element-185" data-mp="2w64yuorrhzce">
                  <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-400" aria-hidden="true" data-id="element-186" data-mp="2hggufeoaakkg" />
                  <div data-id="element-187" data-mp="2mg3dw5upgx1p">
                    <p className="font-display text-xs font-bold uppercase tracking-[0.14em] text-navy-400" data-id="element-188" data-mp="2md7aw3403i6e">
                      Adresse
                    </p>
                    <p className="mt-1 text-[1.02rem] leading-relaxed text-navy-700" data-id="element-189" data-mp="3f2wbwggpni80">
                      {company.addressLines.map(line => <span key={line} className="block" data-id="element-190" data-mp="3561ksimrok3r">
                          {line}
                        </span>)}
                    </p>
                  </div>
                </div>

                <div className="flex gap-4 py-4" data-id="element-191" data-mp="1tre7bravrzik">
                  <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-400" aria-hidden="true" data-id="element-192" data-mp="1ts7hz3cyn95z" />
                  <div data-id="element-193" data-mp="2570x4vpt0lkj">
                    <p className="font-display text-xs font-bold uppercase tracking-[0.14em] text-navy-400" data-id="element-194" data-mp="255pwv5vkhvy6">
                      Site
                    </p>
                    <p className="mt-1 text-[1.02rem] text-navy-700" data-id="element-195" data-mp="1v9mv414mnzbr">
                      {company.website}
                    </p>
                  </div>
                </div>
              </address>

              <div className="mt-8 rounded-2xl bg-navy-50 p-5 sm:p-6" data-id="element-196" data-mp="2nxae5bq92hwa">
                <p className="font-display text-[1rem] font-bold text-navy-800" data-id="element-197" data-mp="2nvz4wwe1chxs">
                  {company.devisNote}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-navy-600" data-id="element-198" data-mp="2exvp8gpqefdw">
                  {decennale}
                </p>
              </div>

              <div className="mt-8" data-id="element-199" data-mp="17hftamg4v04y">
                <h3 className="font-display text-sm font-bold uppercase tracking-[0.16em] text-ember-500" data-id="element-200" data-mp="13hfdaxddygvs">
                  Zone d'intervention
                </h3>
                <p className="mt-3 text-[0.98rem] leading-relaxed text-navy-500" data-id="element-201" data-mp="3f3h8t6bk4ypi">
                  Toute la Corrèze, notamment {zones.join(', ')}.
                </p>
              </div>
            </div>

            <div className="lg:col-span-7" data-id="element-202" data-mp="3o45mu10yaz2e">
              <ContactForm data-id="element-203" data-mp="3sxqoc31r6b6c" />
            </div>
          </div>
        </div>
      </section>
    </>;
}